import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { upsertPatientZoomMeetingSoapNote } from "~/providers/api/patientZoomMeetingsService";
import { UpsertPatientSoapNoteRequest } from "~/providers/utils/types/zoomMeetingTypes";

export const useUpsertPatientZoomMeetingSoapNote = (
  patientId: string,
  sessionId: string,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      request: Omit<UpsertPatientSoapNoteRequest, "patientId" | "sessionId">,
    ) =>
      upsertPatientZoomMeetingSoapNote({
        patientId,
        sessionId,
        ...request,
      }),
    onSuccess: (data, variables) => {
      queryClient.setQueryData(
        ["getPatientZoomMeetingSoapNote", patientId, sessionId],
        data,
      );
      if (variables.data.complete_and_sign) {
        void queryClient.invalidateQueries({
          queryKey: ["getPatientZoomMeetingBillingNote", patientId, sessionId],
        });
      }
      toast.success("SOAP note saved successfully!");
    },
    onError: () => {
      toast.error(
        "We hit trouble saving the SOAP note. Please try again or reload the page.",
      );
    },
  });
};
